{
    "categories": [
        {
            "words": [
                {
                    "name": "banaani",
                    "hint": "Hedelmä, jota apinatkin usein syövät",
                    "image": {
                        "file": "banaani.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "kahvi",
                    "hint": "Kuuma piristävä juoma, jota juodaan usein aamuisin",
                    "image": {
                        "file": "kahvi.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "tee",
                    "hint": "Kuuma juoma, jota juodaan usein aamuisin tai iltaisin ja siihen voidaan lisätä esimerkiksi hunajaa",
                    "image": {
                        "file": "tee.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "leipä",
                    "hint": "Viljasta leivottu ja sen päälle laitetaan usein voita ja mahdollisesti muita lisukkeita",
                    "image": {
                        "file": "leipa.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "puuro",
                    "hint": "Viljaisa ja pehmeä, lusikalla syötävä ruoka. Syödään usein aamupalalla",
                    "image": {
                        "file": "puuro.png",
                        "credit": "Copyright 2018/19 Steve Lee - This work is licensed under the Creative Commons Attribution-ShareAlike 2.0 UK: England & Wales License. Mulberry Symbols. https://mulberrysymbols.org/"
                    }
                },
                {
                    "name": "salaatti",
                    "hint": "Usein aterian lisukkeena. Sisältää erilaisia vihanneksia ja kasviksia",
                    "image": {
                        "file": "salaatti.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "spagetti",
                    "hint": "Eräänlainen pastaruoka, jota syödään usein esimerkiksi lihapullien kanssa",
                    "image": {
                        "file": "spagetti.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "peruna",
                    "hint": "Juures, josta voidaan tehdä esimerkiksi muusia tai ranskalaisia",
                    "image": {
                        "file": "peruna.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "makkara",
                    "hint": "ihavalmiste, jota voidaan esimerkiksi grillata tai paistaa nuotiolla",
                    "image": {
                        "file": "makkara.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "omena",
                    "hint": "Pyöreä, puussa kasvava, hedelmä",
                    "image": {
                        "file": "omena.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "tomaatti",
                    "hint": "Pyöreä vihannes, jota laitetaan usein salaattiin tai leivän päälle",
                    "image": {
                        "file": "tomaatti.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "kurkku",
                    "hint": "Pitkä ja ohut vihannes, jota laitetaan usein salaattiin tai leivän päälle",
                    "image": {
                        "file": "kurkku.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "juusto",
                    "hint": "Leivän päälle ja moniin ruokiin laitettava maitotuote",
                    "image": {
                        "file": "juusto.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "keitto",
                    "hint": "Lämmin, lusikalla syötävä ruoka. Se voi sisältää liemen lisäksi esimerkiksi nakkeja, juureksia, soseutettuja kasviksia tai jauhelihaa.",
                    "image": {
                        "file": "keitto.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "suklaa",
                    "hint": "Kaakaopavuista valmistettu makea herkku, joka on usein levyn tai patukan muodossa",
                    "image": {
                        "file": "suklaa.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "jäätelö",
                    "hint": "Kylmä, pakastimesta löytyvä makea herkku, jota syödään usein kesällä",
                    "image": {
                        "file": "jaatelo.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                }
            ],
            "name": "ruoat ja juomat",
            "image": {
                "word": 0
            }
        },
        {
            "words": [
                {
                    "name": "housut",
                    "hint": "Alavartaloon puettava vaate, jossa on kaksi lahjetta",
                    "image": {
                        "file": "housut.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "t-paita",
                    "hint": "Ylävartaloon puettava vaate, jossa on lyhyet hihat",
                    "image": {
                        "file": "t-paita.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "takki",
                    "hint": "Ylävartaloon puettava ulkovaate, jota käytetään etenkin viileillä ja kylmillä keleillä",
                    "image": {
                        "file": "takki.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "hame",
                    "hint": "Alavartaloon puettava helmallinen vaate, jota etenkin naiset käyttävät esimerkiksi juhlissa tai kesällä",
                    "image": {
                        "file": "hame.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "mekko",
                    "hint": "Ylä- ja alavartaloon ulottuva helmallinen vaate, jota etenkin naiset käyttävät esimerkiksi juhlissa tai kesällä",
                    "image": {
                        "file": "mekko.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "pipo",
                    "hint": "Päähän laitettava asuste, joka lämmittää talvella",
                    "image": {
                        "file": "pipo.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "käsineet",
                    "hint": "Nämä lämmittävät käsiä talvella",
                    "image": {
                        "file": "kasineet.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "huivi",
                    "hint": "Kaulaan kiedottava asuste, joka lämmittää talvella",
                    "image": {
                        "file": "huivi.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "saappaat",
                    "hint": "Pitkävartiset kengät, jotka kestävät vettä",
                    "image": {
                        "file": "saappaat.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "sukat",
                    "hint": "Puetaan jalkoihin",
                    "image": {
                        "file": "sukat.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "farkut",
                    "hint": "Etenkin arkikäyttöön sopivat housut, joiden kanssa voidaan käyttää vyötä",
                    "image": {
                        "file": "farkut.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "neule",
                    "hint": "Ylävartaloon puettava lämmin vaate, joka voi olla tehty esimerkiksi villasta",
                    "image": {
                        "file": "neule.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    },
                    "fallBackPlayer": true
                },
                {
                    "name": "alusvaatteet",
                    "hint": "Ihoa vasten olevat, päällysvaatteiden alle puettavat vaatteet",
                    "image": {
                        "file": "alusvaatteet.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "uimapuku",
                    "hint": "Käytetään esimerkiksi uimahallissa tai rannalla",
                    "image": {
                        "file": "uimapuku.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                }
            ],
            "name": "vaatteet",
            "image": {
                "word": 1
            }
        },
        {
            "words": [
                {
                    "name": "vesisade",
                    "hint": "Kostea ja märkä säätila",
                    "image": {
                        "file": "vesisade.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "aurinkoinen",
                    "hint": "Lämmin säätila, paistaa etenkin kesällä",
                    "image": {
                        "file": "aurinkoinen.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "ukkonen",
                    "hint": "Säätila, jolloin salamoi ja kuuluu jyrinää",
                    "image": {
                        "file": "ukkonen.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "lumisade",
                    "hint": "Talvinen säätila, hiutaleita tippuu taivaalta",
                    "image": {
                        "file": "lumisade.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "pilvinen",
                    "hint": "Säätila, jossa aurinko on piilossa, eli tällöin ei paista",
                    "image": {
                        "file": "pilvinen.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "tuulinen",
                    "hint": "Säätila, jossa käy viima ja puiden oksat heiluvat",
                    "image": {
                        "file": "tuulinen.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "myrsky",
                    "hint": "Hurja säätila, johon voi liittyä voimakasta tuulta, sadetta tai ukkosta",
                    "image": {
                        "file": "myrsky.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "pakkanen",
                    "hint": "Talvella oleva kylmä säätila, kun lämpömittari näyttää miinusta",
                    "image": {
                        "file": "pakkanen.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    },
                    "fallBackPlayer": true
                },
                {
                    "name": "helle",
                    "hint": "Kesällä oleva lämmin säätila, jolloin lämpömittari näyttää vähintään +25 astetta",
                    "image": {
                        "file": "helle.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    },
                    "fallBackPlayer": true
                }
            ],
            "name": "säätilat",
            "image": {
                "word": 1
            }
        },
        {
            "words": [
                {
                    "name": "koira",
                    "hint": "Lemmikkieläin, joka haukkuu",
                    "image": {
                        "file": "koira.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "kissa",
                    "hint": "Lemmikkieläin, joka maukuu",
                    "image": {
                        "file": "kissa.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "lehmä",
                    "hint": "Kotieläin, joka asuu navetassa ja ammuu",
                    "image": {
                        "file": "lehma.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "sika",
                    "hint": "Kotieläin, joka röhkii ja jolla on saparohäntä",
                    "image": {
                        "file": "sika.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "hevonen",
                    "hint": "Kotieläin, joka hirnuu ja jolla voi ratsastaa",
                    "image": {
                        "file": "hevonen.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "käärme",
                    "hint": "Luikerteleva eläin, joka sihisee ja voi olla myrkyllinen",
                    "image": {
                        "file": "kaarme.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "kala",
                    "hint": "Vedessä uiskenteleva eläin, jolla on evät ja kidukset",
                    "image": {
                        "file": "kala.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "lintu",
                    "hint": "Lentävä, siivekäs eläin, joka ääntelee laulaen",
                    "image": {
                        "file": "lintu.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "lammas",
                    "hint": "Kotieläin, joka määkii ja josta voidaan keriä villaa",
                    "image": {
                        "file": "lammas.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "perhonen",
                    "hint": "Kaunis hyönteinen, joka lentää ja joilla voi olla eri värisiä siipiä",
                    "image": {
                        "file": "perhonen.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "ampiainen",
                    "hint": "Lentävä hyönteinen, joka surisee ja voi pistää",
                    "image": {
                        "file": "ampiainen.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "sammakko",
                    "hint": "Hyppivä ja kurnuttava eläin, joka elää esimerkiksi metsässä tai vesistöjen äärellä",
                    "image": {
                        "file": "sammakko.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "sudenkorento",
                    "hint": "Hyönteinen, joka liikkuu etenkin vesistöjen läheisyydessä, lentää ja jolla on suippo ja pitkä ruumis",
                    "image": {
                        "file": "sudenkorento.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                }
            ],
            "name": "eläimet",
            "image": {
                "word": 0
            }
        },
        {
            "words": [
                {
                    "name": "poliisi",
                    "hint": "Viranomainen, joka valvoo lakia ja tutkii rikoksia",
                    "image": {
                        "file": "poliisi.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "opettaja",
                    "hint": "Henkilö, joka jakaa tietoa ja ohjaa oppilaita koulussa",
                    "image": {
                        "file": "opettaja.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "kokki",
                    "hint": "Henkilö, joka valmistaa ruokaa ravintolassa tai keittiössä",
                    "image": {
                        "file": "kokki.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "leipuri",
                    "hint": "Henkilö, joka leipoo leipää, pullaa ja muita leivonnaisia",
                    "image": {
                        "file": "leipuri.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "lääkäri",
                    "hint": "Henkilö, joka tutkii ja hoitaa ihmisiä sairaalassa",
                    "image": {
                        "file": "laakari.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "palomies",
                    "hint": "Henkilö, joka sammuttaa tulipaloja ja pelastaa ihmisiä",
                    "image": {
                        "file": "palomies.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    },
                    "fallBackPlayer": true
                },
                {
                    "name": "maalari",
                    "hint": "Henkilö, joka maalaa seiniä tai tauluja",
                    "image": {
                        "file": "maalari.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "putkimies",
                    "hint": "Henkilö, joka asentaa ja korjaa vesijohtoja sekä viemäreitä",
                    "image": {
                        "file": "putkimies.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "sähköasentaja",
                    "hint": "Henkilö, joka asentaa ja korjaa sähköjärjestelmiä ja -laitteita",
                    "image": {
                        "file": "sahkoasentaja.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "kauppias",
                    "hint": "Henkilö, joka kaupittelee tuotteita ja palvelee asiakkaita kaupassa",
                    "image": {
                        "file": "kauppias.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "rekkakuski",
                    "hint": "Henkilö, joka kuljettaa tavaraa pitkiä matkoja rekalla",
                    "image": {
                        "file": "rekkakuski.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain). Pictures edited"
                    }
                }
            ],
            "name": "ammatit",
            "image": {
                "word": 1
            }
        },
        {
            "words": [
                {
                    "name": "auto",
                    "hint": "Kulkuneuvo, jossa on neljä pyörää ja jota ohjataan ratista",
                    "image": {
                        "file": "auto.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "juna",
                    "hint": "Pitkä kulkuneuvo, joka kulkee pitkiä matkoja raiteilla",
                    "image": {
                        "file": "juna.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "laiva",
                    "hint": "Suuri kulkuneuvo, joka seilaa merellä ja voi kuljettaa tavaraa, autoja ja ihmisiä",
                    "image": {
                        "file": "laiva.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "lentokone",
                    "hint": "Kulkuneuvo, jolla pystyy siirtymään paikasta toiseen ilmateitse",
                    "image": {
                        "file": "lentokone.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "raitiovaunu",
                    "hint": "Pitkä kulkuneuvo, joka kulkee kaupungissa raiteilla",
                    "image": {
                        "file": "raitiovaunu.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "metro",
                    "hint": "Pitkä kulkuneuvo, joka kulkee maan alla raiteilla",
                    "image": {
                        "file": "metro.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "bussi",
                    "hint": "Kulkuneuvo, joka kuljettaa monta matkustajaa kerralla kaupungissa tai pitkällä matkalla",
                    "image": {
                        "file": "bussi.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    },
                    "fallBackPlayer": true
                },
                {
                    "name": "polkupyörä",
                    "hint": "Kulkuneuvo, jota poljetaan",
                    "image": {
                        "file": "polkupyora.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "moottoripyörä",
                    "hint": "Kaksipyöräinen kulkuneuvo, jossa on moottori",
                    "image": {
                        "file": "moottoripyora.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "potkulauta",
                    "hint": "Kulkuneuvo, jota liikutetaan potkimalla jalalla maata",
                    "image": {
                        "file": "potkulauta.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    },
                    "fallBackPlayer": true
                },
                {
                    "name": "pakettiauto",
                    "hint": "Kulkuneuvo, jossa kuljetetaan tavaraa",
                    "image": {
                        "file": "pakettiauto.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "rekka",
                    "hint": "Suuri kulkuneuvo, joka kuljettaa paljon tavaraa pitkiä matkoja",
                    "image": {
                        "file": "rekka.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "vene",
                    "hint": "Kulkuneuvo, joka kulkee vedessä, usein moottorilla tai airoilla",
                    "image": {
                        "file": "vene.png",
                        "credit": "Annakaisa Ojanen CC-BY-NC-SA 3.0"
                    }
                }
            ],
            "name": "kulkuneuvot",
            "image": {
                "word": 1
            }
        },
        {
            "words": [
                {
                    "name": "nukkua",
                    "hint": "Levätä silmät suljettuina",
                    "image": {
                        "file": "nukkua.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "kävellä",
                    "hint": "Liikkua eteenpäin jalkojen avulla",
                    "image": {
                        "file": "kavella.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "juosta",
                    "hint": "Liikkua eteenpäin nopeasti jalkojen avulla",
                    "image": {
                        "file": "juosta.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "syödä",
                    "hint": "Laittaa ruokaa suuhun ja niellä se",
                    "image": {
                        "file": "syoda.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "juoda",
                    "hint": "Laittaa nestettä, kuten vettä, suuhun ja niellä se",
                    "image": {
                        "file": "juoda.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "piirtää",
                    "hint": "Tehdä kuvia kynällä tai tussilla",
                    "image": {
                        "file": "piirtaa.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "laulaa",
                    "hint": "Tuottaa sävelmiä äänellä",
                    "image": {
                        "file": "laulaa.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "tanssia",
                    "hint": "Liikkua musiikin tahdissa",
                    "image": {
                        "file": "tanssia.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "soittaa",
                    "hint": "Käyttää soitinta musiikin tekemiseen",
                    "image": {
                        "file": "soittaa.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "pelata",
                    "hint": "Osallistua peliin tai urheiluun",
                    "image": {
                        "file": "pelata.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "katsoa televisiota",
                    "hint": "Suunnata katse laitteeseen, josta voi katsoa esim. ohjelmia ja uutisia",
                    "image": {
                        "file": "katsoa.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "nauraa",
                    "hint": "Ilmaista iloa äänellä ja ilmeillä",
                    "image": {
                        "file": "nauraa.png",
                        "credit": "Nana Sipola CC-BY-NC-SA 3.0"
                    }
                },
                {
                    "name": "puhua",
                    "hint": "Kertoa asioita tuottamalla sanoja ja ääntä",
                    "image": {
                        "file": "puhua.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "kuunnella",
                    "hint": "Keskittyä ympäristön ääniin",
                    "image": {
                        "file": "kuunnella.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "kirjoittaa",
                    "hint": "Muodostaa sanoja paperille",
                    "image": {
                        "file": "kirjoittaa.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "lukea",
                    "hint": "Tulkita ja ymmärtää kirjoitettua tekstiä",
                    "image": {
                        "file": "lukea.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                }
            ],
            "name": "tekeminen",
            "image": {
                "word": 2
            }
        },
        {
            "words": [
                {
                    "name": "jalkapallo",
                    "hint": "Joukkuelaji, jossa potkitaan mustavalkoista palloa",
                    "image": {
                        "file": "jalkapallo.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "maalaaminen",
                    "hint": "Kuvien tai pintojen värittämistä maalilla",
                    "image": {
                        "file": "maalaaminen.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "tanssiminen",
                    "hint": "Liikkumista musiikin tahdissa",
                    "image": {
                        "file": "tanssiminen.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "laulaminen",
                    "hint": "Äänen käyttöä musiikin tekemiseen",
                    "image": {
                        "file": "laulaminen.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "koripallo",
                    "hint": "Joukkuelaji, jossa heitetään palloa koriin",
                    "image": {
                        "file": "koripallo.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "pesäpallo",
                    "hint": "Suomen kansallispeli, jossa lyödään palloa ja juostaan pesien välillä",
                    "image": {
                        "file": "pesapallo.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "salibandy",
                    "hint": "Sisällä pelattava mailapeli, jossa tehdään maaleja pallolla",
                    "image": {
                        "file": "salibandy.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "jääkiekko",
                    "hint": "Joukkuepeli, jossa pelataan kiekolla jäällä ja tehdään maaleja",
                    "image": {
                        "file": "jaakiekko.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "teatteri",
                    "hint": "Taidelaji, jossa näytellään tarinoita lavalla",
                    "image": {
                        "file": "teatteri.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "kiipeily",
                    "hint": "Liikkumista ylöspäin seinillä tai kallioilla",
                    "image": {
                        "file": "kiipeily.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "kuntosali",
                    "hint": "Harrastus, jossa harjoitellaan lihasvoimaa ja kuntoa, ja nostetaan painoja",
                    "image": {
                        "file": "kuntosali.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "kalastus",
                    "hint": "Kalojen pyytämistä vedestä onkimalla, virvelöimällä tai verkon avulla",
                    "image": {
                        "file": "kalastus.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "metsästys",
                    "hint": "Villieläinten pyytämistä luonnossa",
                    "image": {
                        "file": "metsastys.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "lenkkeily",
                    "hint": "Juoksemista tai kävelyä kuntoilun vuoksi",
                    "image": {
                        "file": "lenkkeily.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "purjehdus",
                    "hint": "Veneilyä, jossa liikutaan tuulen voimalla purjeilla",
                    "image": {
                        "file": "purjehdus.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                }
            ],
            "name": "harrastukset",
            "image": {
                "word": 0
            }
        },
        {
            "words": [
                {
                    "name": "kaukosäädin",
                    "hint": "Laite, jolla ohjataan televisiota tai muita laitteita etäältä",
                    "image": {
                        "file": "kaukosaadin.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "hammasharja",
                    "hint": "Väline hampaiden puhdistamiseen",
                    "image": {
                        "file": "hammasharja.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    },
                    "fallBackPlayer": true
                },
                {
                    "name": "juomapullo",
                    "hint": "Pullo, josta juodaan vettä tai muuta juomaa",
                    "image": {
                        "file": "juomapullo.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "aterimet",
                    "hint": "Haarukka, veitsi ja lusikka",
                    "image": {
                        "file": "aterimet.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "kuulokkeet",
                    "hint": "Laite, jolla kuunnellaan ääntä tai musiikkia korvilla",
                    "image": {
                        "file": "kuulokkeet.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "laturi",
                    "hint": "Johdollinen laite, jolla ladataan esim. puhelinta",
                    "image": {
                        "file": "laturi.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "puhelin",
                    "hint": "Laite, jolla voidaan soittaa, viestitellä ja ottaa kuvia",
                    "image": {
                        "file": "puhelin.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "tietokone",
                    "hint": "Laite, jolla voi työskennellä, pelata ja etsiä tietoa",
                    "image": {
                        "file": "tietokone.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "henkari",
                    "hint": "Esine, jonka avulla ripustetaan vaatteita",
                    "image": {
                        "file": "henkari.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "avaimet",
                    "hint": "Välineet, joilla avataan ja lukitaan ovia",
                    "image": {
                        "file": "avaimet.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "laukku",
                    "hint": "Olalla kannettava säilytystila tavaroille",
                    "image": {
                        "file": "laukku.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "sateenvarjo",
                    "hint": "Suojaa sateelta, kun se avataan pään päälle",
                    "image": {
                        "file": "sateenvarjo.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "reppu",
                    "hint": "Selässä kannettava laukku",
                    "image": {
                        "file": "reppu.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "lompakko",
                    "hint": "Pieni kotelo, jossa säilytetään rahaa ja kortteja",
                    "image": {
                        "file": "lompakko.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                },
                {
                    "name": "pankkikortti",
                    "hint": "Kortti, jolla voi maksaa",
                    "image": {
                        "file": "pankkikortti.png",
                        "credit": "Copyright 2018/19 Steve Lee - This work is licensed under the Creative Commons Attribution-ShareAlike 2.0 UK: England & Wales License. Mulberry Symbols. https://mulberrysymbols.org/"
                    }
                },
                {
                    "name": "silmälasit",
                    "hint": "Auttavat näkemään paremmin",
                    "image": {
                        "file": "silmalasit.png",
                        "credit": "Pictograms author: Sergio Palao. Origin: ARASAAC (http://www.arasaac.org). License: CC (BY-NC-SA). Owner: Government of Aragon (Spain)"
                    }
                }
            ],
            "name": "arkipäiväiset esineet",
            "image": {
                "word": 1
            }
        }
    ]
}
